import EventEmitter from "events";

export class Site extends EventEmitter {
    constructor(obj) {
        super();
        Object.assign(this, obj)
    }
}